import * as React from "react";
import ReactTable from "react-table";
import {Documento} from "../../documentos/modelo/Documento";
import { FiltroReporte } from "../modelo/Reporte";
import {Glyphicon, ButtonToolbar, OverlayTrigger, Tooltip} from "react-bootstrap";
import ModalDatosIndependiente from "./ModalDatosIndependiente";
import { EstadoIndependiente } from "../modelo/EstadosIndependiente";

export default class TablaReportesIndependientes extends React.Component<TablaReportesIndependientesProps> {

    columns = [{
        Header: "Identificación Independiente",
        accessor: "afiliado.identificacion",
        width: 160
    }, {
        Header: "Nombre Independiente",
        accessor: "afiliado.nombreLegal",
    }, {
        Header: "Empresa Contratante",
        accessor: "dniEmpleador",
        width: 130
    },{
        Header: "Fecha Radicación",
        accessor: "fechaRadicacion",
        width: 130 
    }, {
        Header: "Estado",
        accessor: "estado",
        width: 100 
    },{
        Header: "Poliza - Inicio Cobertura",
        accessor: "poliza",
        Cell: props => (this.renderFechaCobertura(props)),
        width: 150
    }, {
        Header: "Ver Datos",
        accessor: "dniEmpleador",
        Cell: props => (this.renderDetallesTrabajador(props)),
        width: 80 
    }, {
        Header: "Observación",
        accessor: "observacion",
        Cell: props => (this.renderCampoObservacion(props)),
        width: 100
    }];

    renderCampoObservacion(props: any) {
        return(
            <div className={"text-center"}>
                <ButtonToolbar>
                    <OverlayTrigger placement="top"
                                    overlay={
                                        <Tooltip id="tooltip">
                                            {this.renderObservacion(props)}
                                        </Tooltip>}>
                        <span className={"btns " + (this.obtenerClassName(props.original.estado))}><Glyphicon
                            glyph={"info-sign"}/>  Revisar</span>
                    </OverlayTrigger>
                </ButtonToolbar>
            </div>
        );
    }

    renderDetallesTrabajador = (props: any) => {
        return(
            <div>
                <ModalDatosIndependiente
                    nombreTrabajador={props.original.afiliado ? props.original.afiliado.nombreLegal : ""}
                    dniEmpleador={props.original.dniEmpleador}
                    dniIndependiente={props.original.afiliado ? props.original.afiliado.identificacion: ""}
                    id={props.original.id}
                />
            </div>
        );
    }

    render() {
        const {documentos,paginas, tamanoPagina, paginaActual} = this.props;

        let numRegistros = 0;
        if (documentos.length < tamanoPagina) {
            numRegistros = documentos.length;
        } else {
            numRegistros = tamanoPagina;
        }
        return (
            <div className={"panel panel-success"}>
                <div className={"panel-heading"}>
                    <h2 className={"panel-title-white"}>
                        <span className="badge">{documentos.length}</span> Documentos encontrados
                    </h2>
                </div>
                <ReactTable data={documentos}
                            columns={this.columns}
                            manual
                            defaultPageSize={numRegistros}
                            pageSizeOptions={this.calcularOpciones(numRegistros)}
                            page={paginaActual}
                            sortable={false}
                            resizable={false}
                            previousText={"Anterior"}
                            nextText={"Siguiente"}
                            loadingText={"Cargando..."}
                            noDataText={"No se ha encontrado información."}
                            pageText={"Página"}
                            ofText={"de"}
                            rowsText={""}
                            className={"-highlight -striped"}
                            pages={paginas}
                            onPageChange={(pageIndex) => {
                                this.consultarCambioPagina(tamanoPagina, pageIndex, tamanoPagina);
                            }}
                            onPageSizeChange={(pageSize, pageIndex) => {
                                this.consultarCambioPagina(pageSize, pageIndex, tamanoPagina);
                            }}
                />
            </div>
        );
    }

    consultarCambioPagina(pageSize: number, pageIndex: number, tamanoPagina: number) {
        
        const filtroReporte: FiltroReporte = {
            dni: this.props.filtroReporte.dni,
            oficina: this.props.filtroReporte.oficina,
            tipoCliente: "OI",
            estado: this.props.filtroReporte.estado,
            fechaInicio: this.props.filtroReporte.fechaInicio,
            fechaFin: this.props.filtroReporte.fechaFin,
            fechaInicioAprobacion: this.props.filtroReporte.fechaInicioAprobacion,
            fechaFinAprobacion: this.props.filtroReporte.fechaFinAprobacion,
            tipoTramite: this.props.filtroReporte.tipoTramite,
            registrosPorPagina: pageSize ? pageSize : tamanoPagina,
            pagina: pageIndex,
        };
        this.props.consultaPaginada(filtroReporte);
    }

    calcularOpciones(tamanoPagina : number) {
        const arreglo = [10, 20, 25, 50, 100];
        const elemento = arreglo.find(valor => valor === tamanoPagina);
        if( elemento ) {
            return arreglo;
        } else {
            return [...arreglo,tamanoPagina].sort( (a, b) => {return a-b;} );
        }
     }

    renderFechaCobertura = (props: any) => {
        return(
            <div className={"text-center"}>
                {props.original.estado === EstadoIndependiente.aprobado ? `${props.original.poliza} - ${props.original.fechaInicioCobertura}` : ``}
            </div>

        );
    }

    renderObservacion = (props: any) => {
        if (props.original.estado === EstadoIndependiente.pendiente) {
            return `Está pendiente la gestión por parte de la empresa contratante desde servicios transaccionales`;
        } else if(props.original.estado === EstadoIndependiente.preregistro) {
            return `Pendiente anexar al formulario el contrato por prestación de servicios`;
        } else if(props.original.estado === EstadoIndependiente.procesando) {
            return `Procesando afiliación del trabajador independiente a un nuevo contratante no afiliado`;
        } else {
            return props.value;
        }
    }

    obtenerClassName(estado: string) {
        return estado === EstadoIndependiente.invalido ? "btn-danger" : (estado === EstadoIndependiente.aprobado ? "btn-success": "btns-primary");
    }

}

interface TablaReportesIndependientesProps {
    documentos: Array<Documento>,
    filtroReporte: FiltroReporte,
    paginas: number,
    tamanoPagina: number,
    paginaActual: number,
    consultaPaginada?: (filtroReporte: FiltroReporte) => void
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/reportes/componentes/TablaReportesIndependientes.tsx